import React from 'react';

import InfoRow from '@vlabs/shared/components/info-row/InfoRow';
import { AnalyticStreamLink } from '@vlabs/shared/components/stream-link/AnalyticStreamLink';
import { parseISOToLocale } from '@vlabs/shared/utils';
import { Tag, useWindowSize } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { buildLocationString } from '@vlapps/point/src/utils/location';

import st from './VideoAnalyticInfoCard.module.sass';

export const VideoAnalyticInfoCell = ({ event_type, create_time, end_time, event }) => {
  const { t } = useTranslation();
  const windowSize = useWindowSize();

  if (!event || !event_type) return null;

  return (
    <div className={st.VideoAnalyticInfoCell}>
      <Tag
        className={st.Tag}
        data-testid='InfoCardTagVA'
        kind="secondary"
        size={windowSize.width < 1920 ? 'medium' : 'large'}
        value={t(`videoAnalytics:archivePage.infoCard.tag.${event_type}`, { defaultValue: t('videoAnalytics:archivePage.infoCard.tag.unknown') })}
      />
      <InfoRow
        className={st.InfoRow}
        data-testid="infoCell.dateCreated"
        title={t('date created')}
        value={`${parseISOToLocale(create_time)} - ${parseISOToLocale(end_time)}`}
      />
      <InfoRow
        className={st.InfoRow}
        data-testid="infoCell.source"
        title={t('source')}
        value={<AnalyticStreamLink streamId={event.stream_id} />}
      />
      <InfoRow
        className={st.InfoRow}
        data-testid="infoCell.location"
        title={t('location')}
        value={buildLocationString(event)}
      />
    </div>
  );
};
